
<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">


            <div class="row" *ngIf="signUpTO">
                <div class="col-md-8 mx-auto">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">

                                <h1><img src="assets/img/brand/sprout.png" style="width: 40px;"/> Sprout<span class="sprout-scribe">Scribe</span></h1>
                                <h4 class="text-muted">Enter your activation code</h4>

                                <h5>
                                    We have sent an activation code to your email address<span *ngIf="signUpTO && signUpTO.email">, {{signUpTO.email}}</span>. Please enter that code below:
                                </h5>

                                <div class="card bg-light mb-3 mt-3">
                                    <!--      <div class="card-header">Header</div>-->
                                    <div class="card-body">

                                        <form [formGroup]="confirmationForm" (ngSubmit)="onActivateAccount()">

                                            <div class="confirmation-form-orig">


                                                <div class="form-group">
                                                    <label for="activationCode">Activation Code:</label>
                                                    <input #activationCode type="number" class="form-control" name="activationCode" id="activationCode" required="true"
                                                           autofocus=""
                                                           formControlName="activationCode" maxlength="6"
                                                           style="font-size: 2em; height: 60px; font-family: Courier New, Courier, Verdana; font-weight: bold; color: darkgreen;"/>
                                                </div>

                                                <div class="alert alert-warning" *ngIf="accountActivationAttempts > 1">
                                                    <h5>Invalid activation code! Please check your email and try again.</h5>
                                                </div>

                                                <button type="button" class="btn btn-link sprout-green-link" (click)="onResendCode()" aria-label="Resend Code">Resend code
                                                </button>
                                                <button type="button" style="background-color: #4f9b35 !important;" class="btn btn-success px-4 pull-right sprout-green-btn"
                                                        [disabled]="!confirmationForm.valid || !confirmationForm.value.activationCode "
                                                        (click)="onActivateAccount()"
                                                >Activate
                                                </button>

                                            </div>
                                        </form>

                                    </div>
                                </div>

                                <div *ngIf="resentInd" class="alert alert-success">
                                    Your activation code has been resent. Please check your email.
                                </div>

                                <div *ngIf="errorCode" class="alert alert-info">
                                    {{errorMessage}}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    </main>
</div>




